"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUsers = void 0;
var config_1 = require("../helpers/config");
var envConsts_1 = require("../helpers/envConsts");
var getQueryString_1 = require("../helpers/getQueryString");
var fetchWithToken_1 = require("../token/fetchWithToken");
var handlePendingUsers = function (_a) {
    var pagination = _a.pagination, results = _a.results;
    return ({
        pagination: pagination,
        results: results.map(function (user) { return (__assign(__assign({}, user), { name: user.status === 'pending' || user.name === 'New Member'
                ? user.email
                : user.name })); }),
    });
};
var fetchUsers = function (_a) {
    var projectId = _a.projectId, offset = _a.offset, limit = _a.limit;
    var query = (0, getQueryString_1.default)({ offset: offset, limit: limit });
    return (0, fetchWithToken_1.fetchWithToken)("".concat((0, config_1.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_API), "/v1/projects/").concat(projectId, "/users").concat(query)).then(handlePendingUsers);
};
exports.fetchUsers = fetchUsers;
